export const white = '#FFFFFF';
export const black = '#000000';
export const black1 = '#14191F';
export const black2 = '#14191F0F';

export const blue = '#0072CE';
export const blue2 = '#3766FF';
export const blue3 = '#006ABF';

export const yellow = '#FFC72C';
export const yellow1 = '#FFC72CD8';

export const yellow3 = '#FBC32B';

export const red = '#BB0000';
export const red2 = '#FF5F57';
export const red3 = '#FFEFEF';
export const red4 = '#FF5F5714';

export const grey = '#939393';
export const grey2 = '#FBFBFB';
export const grey3 = '#7B7E81';
export const grey4 = '#EAEAEA';
export const grey5 = '#9E9E9E';
export const grey6 = '#CCCCCC';
export const grey7 = '#4D483B';
export const grey8 = '#727272';
export const grey9 = '#F3F4F6';
export const grey10 = '#F9FAFB';
export const grey11 = '#F6F7F8';
export const grey12 = '#14191F8F';
export const grey13 = '#14191F1A';
export const grey11Opacity85 = '#F5F7F8D8';
export const grey13Opacity60 = '#14191F99';

export const grey13Opacity38 = '#14191F38';
export const green = '#24B07E';
export const green1 = '#24B07E13';
export const green2 = '#24B07E26';

export const green3 = '#24B07EF2';
